"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { getSocket } from "@/lib/socket/client";
import type { Socket } from "socket.io-client";
export function useSocket() {
  const $ = _c(5);
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const s = getSocket();
      setSocket(s);
      const onConnect = function onConnect() {
        setIsConnected(true);
      };
      const onDisconnect = function onDisconnect() {
        setIsConnected(false);
      };
      s.on("connect", onConnect);
      s.on("disconnect", onDisconnect);
      if (s.connected) {
        setIsConnected(true);
      }
      return () => {
        s.off("connect", onConnect);
        s.off("disconnect", onDisconnect);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isConnected || $[3] !== socket) {
    t2 = {
      socket,
      isConnected
    };
    $[2] = isConnected;
    $[3] = socket;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}